var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarNextMonth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.293 18.707C11.1056 18.5195 11.0002 18.2652 11.0002 18C11.0002 17.7349 11.1056 17.4806 11.293 17.293L14.586 14L11.293 10.707C11.1109 10.5184 11.0101 10.2658 11.0124 10.0036C11.0146 9.74144 11.1198 9.49063 11.3052 9.30522C11.4906 9.11981 11.7414 9.01465 12.0036 9.01237C12.2658 9.01009 12.5184 9.11088 12.707 9.29304L16.707 13.293C16.8945 13.4806 16.9998 13.7349 16.9998 14C16.9998 14.2652 16.8945 14.5195 16.707 14.707L12.707 18.707C12.5195 18.8945 12.2652 18.9998 12 18.9998C11.7349 18.9998 11.4806 18.8945 11.293 18.707Z",
    fill: "#374151"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 5.5,
    stroke: "#F3F4F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarNextMonth);
export default __webpack_public_path__ + "static/media/calendar-next-month.76ae91d44a164040752037a0628a9b9c.svg";
export { ForwardRef as ReactComponent };